export function setRollover(index: number, length: number, add: number = +1) {
      if( length == 0 ) return 0
      return (length + index + add) % length
}
